import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { KEYS } from 'helpers/react-query.config';
import { useApiContext } from 'context/ApiContext';
import { useGlobalContext } from 'context/GlobalContext';

const PROYECT_KEY = KEYS.client.services.getServiceDetail();

type Props = {
  ticketServiceId?: number;
};

function useGetProyectDetail({ ticketServiceId }: Props) {
  const { showApiError } = useGlobalContext();
  const { client: clientApi } = useApiContext();
  const { t } = useTranslation('global');

  const clientProjectDetail = useQuery(
    [PROYECT_KEY, ticketServiceId],
    () => clientApi.services.detail(ticketServiceId),
    {
      select: (data) => data?.data?.data,
      enabled: !!ticketServiceId,
      onError: (error) => showApiError(error, t('errorMessages.clientProject')),
      refetchOnWindowFocus: false
    }
  );

  return {
    clientProjectDetail
  };
}

export default useGetProyectDetail;
